import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { LoadingIcon } from '../LoadingIcon.js';
import style from './QuantityLoader.module.scss.js';

const QuantityLoader = (props) => {
    const { size = 'large' } = props;
    return (jsx(LoadingIcon, { iconType: "spinner", className: classNames(style['z-qty-loader'], {
            [style[`z-qty-loader--${size}`]]: size !== 'large',
        }) }));
};

export { QuantityLoader };
//# sourceMappingURL=QuantityLoader.js.map
